module.exports = __webpack_public_path__ + "img/bf6f2b4.png";